import { useEffect, useState } from 'react'
import api from 'common/api'
import { SchoolType, Title1Program } from '../types'

export interface HighschoolData {
  id: string
  name: string
  city: string
  state: string
  zip?: string
  address?: string
  schoolType?: SchoolType
  nextVisitDate?: string
  title1Program?: Title1Program
  religiousAffiliation?: string
  locale?: string
  ceebCode?: string
  isActive: boolean
  contactUserId?: string
  seniorClassSize?: number
  pctFreeReducedLunch?: number
  isTitle1Eligible?: boolean
  website?: string
}
export interface HighschoolResults {
  highschool: HighschoolData
}

export default function useGetHighschoolPreviewData({
  highschoolId,
  enabled = true,
}: {
  highschoolId?: string
  enabled?: boolean
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [data, setData] = useState<HighschoolResults | null>(null)
  const [error, setError] = useState<unknown>(null)
  useEffect(() => {
    async function fetchData(highschoolId: string) {
      setIsLoading(true)
      setIsSuccess(false)
      setIsError(false)
      setError(null)

      const url = `/api/highschools/explore/${highschoolId}`

      try {
        const data = await api.get<HighschoolResults>(url, {})
        if (data) {
          setData(data)
          setIsSuccess(true)
        } else {
          setIsError(true)
          setError('failed to load highschool')
        }
      } catch (err) {
        setData(null)
        setIsError(true)
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    if (highschoolId && enabled) {
      fetchData(highschoolId)
    }
  }, [highschoolId, enabled])

  return { isLoading, isSuccess, isError, error, data }
}
